import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getTagsLookups, createTag } from './thunks';
import { TagsState } from './types';

export const name = 'tags';

const initialState: TagsState = {
  lookups: {
    data: [],
    status: 'idle',
  },
  createTag: {
    data: null,
    status: 'idle',
  },
};

export const getTagsLookupsAsync = createAsyncThunk(
  name + '/getTagsLookups',
  getTagsLookups
);

export const createTagAsync = createAsyncThunk(name + '/createTag', createTag);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTagsLookupsAsync.pending, (state) => {
        state.lookups.status = 'loading';
      })
      .addCase(getTagsLookupsAsync.fulfilled, (state, action) => {
        state.lookups = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getTagsLookupsAsync.rejected, (state) => {
        state.lookups.status = 'failed';
      })
      .addCase(createTagAsync.pending, (state) => {
        state.createTag.status = 'loading';
      })
      .addCase(createTagAsync.fulfilled, (state, action) => {
        state.createTag = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createTagAsync.rejected, (state) => {
        state.createTag.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
